import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getUserSignatureStatus({ clinicId }) {
    const response = await axiosPrivate.get(`/v3/signatures/status`, {
      params: { clinicId },
    });
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async generateSignature({ clinicId, pin, signature }) {
    const response = await axiosPrivate.post(`/v3/signatures`, {
      clinicId,
      pin,
      signature,
    });
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
